import axios from '@axios'

const route = 'calendar'

export default {
  namespaced: true,
  state: {
    loadingEvent: false,
    onlyShow: true,
    dialogNewEvent: false,
    widthDialog: 750,
    showSearchCustomer: false,
    window: 'service',
    eventSaved: {},
    event: {},
    employee: {},
    customer: {},
    services: [],
    servicesRemoved: [],
    servicesAvailable: [],
    loadingServicesAvailable: false,
    editService: {},
    tabCustomer: 'empty',
    employeeServices: [], // serviços disponiveis para o profissinal
  },
  getters: {
    getLoadingEvent(state) {
      return state.loadingEvent
    },
    getLoadingServicesAvailable(state) {
      return state.loadingServicesAvailable
    },
    getDialogNewEvent(state) {
      return state.dialogNewEvent
    },
    getCustomer(state) {
      return state.customer
    },
    getEmployee(state) {
      return state.employee
    },
    getEvent(state) {
      return state.event
    },
    getService(state) {
      return state.services
    },
    getWindow(state) {
      return state.window
    },
    getEditService(state) {
      return state.editService
    },
    getWidthDialog(state) {
      return state.widthDialog
    },
    getServicesAvailable(state) {
      return state.servicesAvailable
    },
    getEventSaved(state) {
      return state.eventSaved
    },
    getTabCustomer(state) {
      return state.tabCustomer
    },
    getEmployeeServiceSelect(state) {
      return state.employeeServices
    },
    getOnlyShow(state) {
      return state.onlyShow
    },

  },

  mutations: {
    setClear(state) {
      state.event = {}
      state.services = []
      state.customer = {}
      state.employee = {}
      state.editService = {}
      state.tabCustomer = 'empty'
      state.servicesRemoved = []
    },
    setLoadingEvent(state, loading) {
      state.loadingEvent = loading
    },
    setOnlyShow(state, onlyShow) {
      state.onlyShow = onlyShow
    },
    setEmployeeServiceSelect(state, employeeServices) {
      state.employeeServices = employeeServices
    },
    setDialogNewEvent(state, dialog) {
      state.dialogNewEvent = dialog
    },
    setWidthDialog(state, width) {
      state.widthDialog = width
    },
    setWindow(state, window) {
      state.window = window
    },
    setEditService(state, service) {
      state.editService = service
    },
    setCustomer(state, customer) {
      state.customer = customer
    },
    setEmployee(state, employee) {
      state.employee = employee
    },
    setService(state, service) {
      state.services = service
    },
    addService(state, service) {
      state.services.push(service)
    },
    setEvent(state, event) {
      state.event = event
    },
    removeService(state, service) {
      // se ainda nao tem registro no bd retira do array
      if (service.id == null || service.id === undefined) {
        state.services.splice(state.services.indexOf(service), 1)
      } else {
        // array de serviço removidos
        state.servicesRemoved.push(service)
        state.services = state.services.filter(item => item !== service)
      }
    },
    setServicesAvailable(state, services) {
      state.servicesAvailable = services
    },
    setEventSaved(state, event) {
      state.eventSaved = event
    },
    setTabCustomer(state, tab) {
      state.tabCustomer = tab
    },
    setEventStatus(state, status) {
      state.event.status = status
    },
  },

  actions: {
    index(context, date) {
      return axios.get(`${route}/index?date=${date}`)
    },
    getInvoice(context, sale_id) {
      return axios.get(`${route}/get_invoice/${sale_id}`)
    },

    // SEARCH FUNCIONARIO
    getEmployees() {
      return axios.get(`${route}/get_employees`)
    },

    // SEARCH CUSTOMER
    loadSearchCustomer(context, search) {
      return axios.get(`helper/get_customers?search=${search}`)
    },

    searchService(context, search) {
      return axios.get(`helper/get_services?search=${search}`)
    },

    getEmployeeService(context, employee_id) {
      return axios.get(`${route}/get_employee_service/${employee_id}`)
    },
    loadService(context) {
      context.state.loadingServicesAvailable = true
      context.state.servicesAvailable = []
      axios.get('helper/get_services').then(response => {
        context.commit('setServicesAvailable', response.data)

        // this.setServicesAvailable(response.data)
      }).finally(() => {
        context.state.loadingServicesAvailable = false
      })
    },

    // salvo os serviços editados
    updateService(context, service) {
      return axios.put(`${route}/update/${service.id}`, service)
    },

    // Salvar Evento
    storeEvent(context) {
      const event = context.getters.getEvent
      const services = context.getters.getService
      const lastService = services[services.length - 1]
      const fisrstService = services[0]

      const payload = {
        customer: context.getters.getCustomer,
        employee: event.employee,
        service: context.getters.getService,
        name: fisrstService.service.name,
        color: fisrstService.service.color,
        start: event.start,
        end: lastService.end,
        status: event.status,
        cancellation_date: event.cancellation_date || null,
        reason_cancellation: event.reason_cancellation || null,
        services_removed: context.state.servicesRemoved,
      }

      // formata a data para o formato do banco
      payload.start = formatDate(payload.start)
      payload.end = formatDate(lastService.end)

      payload.service = payload.service.map(service => {
        service.start = formatDate(service.start)
        service.end = formatDate(service.end)

        return service
      })

      if (event.id) {
        // atualiza evento
        return axios.put(`${route}/update/${event.id}`, payload)
      }

      // cria um novo evento
      return axios.post(`${route}/store`, payload)
    },

    loadEventPerId(context, id) {
      context.commit('setClear')
      context.commit('setLoadingEvent', true)
      axios.get(`${route}/get_schedule/${id}`).then(response => {
        const event = response.data
        context.commit('setEvent', event)

        if (event.customer) {
          context.commit('setCustomer', event.customer)
          context.commit('setTabCustomer', 'customer')
        } else {
          context.commit('setCustomer', null)
          context.commit('setTabCustomer', 'empty')
        }

        context.commit('setService', event.calendar_service)
        context.commit('setWindow', 'summary')
      }).finally(() => {
        context.commit('setLoadingEvent', false)
      })
    },
    getLink(){
      return axios.get(`${route}/get_link`)
    }
  },

}

function formatDate(date) {
  const dataAtual = new Date(date)

  // Extrai o ano, mês e dia da data atual
  const ano = dataAtual.getFullYear()
  const mes = (dataAtual.getMonth() + 1).toString().padStart(2, '0') // os meses são baseados em zero
  const dia = dataAtual.getDate().toString().padStart(2, '0')

  // Concatena as partes da data no formato desejado
  const dataFormatada = `${ano}-${mes}-${dia} ${dataAtual.toLocaleTimeString('pt-BR')}`

  return dataFormatada
}
